import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import { getDocumentTitle } from "../helpers";
import { isBlackFridayActive } from "../../../config/blackFridayConfig";
import BFBackground from "../../../icons/BF2025/BFBackground.svg";
import Footer from "../Footer";

import * as styles from "./styles.module.scss";

/**
 * Wraps a component in the layout used for the login.
 *
 * @param {ReactElement} WrappedComponent The React component to wrap.
 * @param {string}       documentTitle    The document title.
 *
 * @returns {ReactElement} The login layout with the wrapped component.
 */
export default ( WrappedComponent, documentTitle ) => {
	return class LoginLayout extends Component {
		/**
		 * Renders the component.
		 *
		 * @returns {ReactElement} The rendered component.
		 */
		render() {
			const isBF        = isBlackFridayActive();
			const layoutClass = isBF ? styles.layoutLoginBF : styles.layoutLogin;

			// I was having some issues importing the SVG background image in the css file. This appeared to work.
			const layoutStyle = isBF ? {
				backgroundImage: `url(${ BFBackground })`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			} : {};

			return (
				<DocumentTitle title={ getDocumentTitle( documentTitle ) }>
					<div className={ layoutClass } style={ layoutStyle }>
						<div className={ styles.whitePaper }>
							<WrappedComponent { ...this.props } />
						</div>
						<Footer variant="dark" />
					</div>
				</DocumentTitle>
			);
		}
	};
};
